<template>
	<div v-if="store.events.items" class="flex flex-col gap-6">
		<h2 class="font-bold text-xl md:text-3xl">Kalender</h2>
		<!-- Loopar igenom varje dag-grupp -->
		<div v-for="(events, dateLabel) in groupedEvents" :key="dateLabel" class="flex flex-col gap-4">
			<!-- Dynamisk dag-rubrik (t.ex. Idag, Imorgon, Tors 7 sep) -->
			<h2 class="font-bold text-xl capitalize border-t pt-6">{{ dateLabel }}</h2>
			
			<ul class="flex flex-col gap-6">
				<!-- Loopar igenom avsnitten för den specifika dagen -->
				<li v-for="event in events" :key="event.link">
					<a rel="noopener noreferrer" target="_blank" :href="event.link" class="flex flex-col gap-1 hover:opacity-75">
						<span class="text-red text-xs font-bold uppercase leading-5">{{ event.organizer }}</span>
						<div class="flex flex-row gap-3 leading-5">
							<!-- Visar nu bara klockslag eftersom dagen står i rubriken -->
							<span class="text-xs uppercase leading-5">{{ format(new Date(event.start_time), 'HH:mm') }}</span>
							<span class="text-xs uppercase leading-5" v-for="location in event.locations" :key="location">{{ location }}</span>
						</div>
						<h3 class="text-base font-bold leading-tight">{{ event.title }}</h3>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
	import { computed } from 'vue'
	import { usePodcastStore } from '../stores/podcastStore'
	import { format, isToday, isTomorrow } from 'date-fns'
	import { sv } from 'date-fns/locale' // Importera svensk lokalisering

	const store = usePodcastStore()

	const getDateLabel = (date) => {
		if (isToday(date)) return 'Idag'
		if (isTomorrow(date)) return 'Imorgon'
		return format(date, 'EEEE, d MMMM', { locale: sv })
	}

	const groupedEvents = computed(() => {
		const groups = {}
		const today = new Date();
		today.setHours(0, 0, 0, 0);

		const sortedEvents = [...store.events.items].sort((a, b) => {
			return new Date(a.start_time) - new Date(b.start_time)
		})

		sortedEvents.forEach(event => {
			const date = new Date(event.start_time)
			const label = getDateLabel(date)
			
			if (date < today) {
				return;
			}

			if (!groups[label]) {
				groups[label] = []
			}
			groups[label].push(event)
		})

		return groups
	})
</script>
